import { PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
var HighlightSearchPipe = /** @class */ (function () {
    // transform(value: any, args?: any): any {
    //   return null;
    // }
    function HighlightSearchPipe(sanitizer) {
        this.sanitizer = sanitizer;
    }
    HighlightSearchPipe.prototype.transform = function (value, args) {
        if (!args) {
            return value;
        }
        // Match in a case insensitive manner
        var re = new RegExp(args, 'gi');
        var match = value.match(re);
        // If there's no match, just return the original value.
        if (!match) {
            return value;
        }
        var replacedValue = value.replace(re, "<mark>" + match[0] + "</mark>");
        return this.sanitizer.bypassSecurityTrustHtml(replacedValue);
    };
    return HighlightSearchPipe;
}());
export { HighlightSearchPipe };
